import * as React from 'react';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

const EditModeOverlay = () => (
	<div className="dash-box-overlay">
		<h1>
			<Trans i18nKey="dashboard.widgets.config.notdisplayed">
				This widget does not support live preview during config mode
			</Trans>
		</h1>
	</div>
);

export default EditModeOverlay;
